import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const employeeApi = createAsyncThunk(
  "employee",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.name = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/employee", {
      params, // Pass the parameters to the API request
    });
    return response.data;
  }
);

const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employee: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(employeeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(employeeApi.fulfilled, (state, action) => {
        state.employee = action.payload;
        state.loading = false;
      })
      .addCase(employeeApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default employeeSlice.reducer;
